"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useErrorNavigation2 = require("../../hooks/error/useErrorNavigation");
var _services = require("../../services");
var _HeaderTop = _interopRequireDefault(require("../shared/HeaderTop"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ErrorHeader = function ErrorHeader() {
  var _useErrorNavigation = (0, _useErrorNavigation2.useErrorNavigation)(),
    onRestart = _useErrorNavigation.onRestart;
  var restartComponent = function restartComponent() {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.LinkWithIcon, {
      appearance: "secondary",
      text: _services.locale.localeString('Questionnaire.RestartIcon'),
      state: "selected",
      id: "questionnaire-button-restart",
      icon: {
        name: 'refresh',
        justify: 'right'
      },
      onClick: onRestart,
      size: 2
    });
  };
  return /*#__PURE__*/_react.default.createElement(_HeaderTop.default, {
    actionComponent: restartComponent()
  });
};
var _default = ErrorHeader;
exports.default = _default;